// Visitor categories + merchant suggestions, shared across the web app.
// Mirrors backend VISITOR_TYPES; merchant is free text with these quick-picks.

export const VISITOR_TYPES = [
  { code: "GUEST", label: "Guest", icon: "UserCircle", accent: "cyan" },
  { code: "DELIVERY", label: "Delivery", icon: "Package", accent: "lime" },
  { code: "CAB", label: "Cab", icon: "Car", accent: "amber" },
  { code: "SERVICE", label: "Service", icon: "Wrench", accent: "cyan" },
  { code: "VENDOR", label: "Vendor", icon: "Storefront", accent: "lime" },
  { code: "OTHER", label: "Other", icon: "DotsThreeCircle", accent: "cyan" },
];

export const MERCHANTS = {
  DELIVERY: ["Amazon", "Flipkart", "Swiggy", "Zomato", "Blinkit", "Zepto", "BigBasket", "Dunzo", "Courier", "Other"],
  CAB: ["Uber", "Ola", "Rapido", "Other"],
  SERVICE: ["Maid", "Cook", "Driver", "Plumber", "Electrician", "Carpenter", "Gas", "Milkman", "Newspaper", "Other"],
};

export const VISITOR_STATUS = {
  PENDING: { label: "Awaiting approval", color: "amber" },
  APPROVED: { label: "Approved", color: "lime" },
  DENIED: { label: "Denied", color: "pink" },
  CHECKED_IN: { label: "Inside", color: "cyan" },
  CHECKED_OUT: { label: "Left", color: "white" },
  EXPIRED: { label: "Expired", color: "white" },
};

export const typeMeta = (code) => VISITOR_TYPES.find((t) => t.code === code) || VISITOR_TYPES[0];

// Domestic / daily help types (MyGate-style). icon = phosphor component name.
export const HELP_TYPES = [
  { code: "MAID", label: "Maid", icon: "Broom" },
  { code: "COOK", label: "Cook", icon: "CookingPot" },
  { code: "NANNY", label: "Nanny", icon: "Baby" },
  { code: "DRIVER", label: "Driver", icon: "Car" },
  { code: "DOMESTIC", label: "Domestic Help", icon: "House" },
  { code: "CARETAKER", label: "Caretaker", icon: "Heart" },
  { code: "GARDENER", label: "Gardener", icon: "Plant" },
  { code: "MILKMAN", label: "Milkman", icon: "Coffee" },
  { code: "NEWSPAPER", label: "Newspaper", icon: "Newspaper" },
  { code: "NURSE", label: "Nurse / Attendant", icon: "FirstAid" },
  { code: "TUTOR", label: "Tutor", icon: "GraduationCap" },
  { code: "OTHER", label: "Other", icon: "UserCircle" },
];
export const helpTypeMeta = (code) => HELP_TYPES.find((t) => t.code === code) || HELP_TYPES[HELP_TYPES.length - 1];
